import '.ce{position:relative;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.gk{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.q{justify-content:center;}.ssr-plugin'
import '.b1{align-items:flex-start;}.ssr-plugin'
import '.p{padding:2rem;}.ssr-plugin'
import '.cx{background:var(--shades-white);}.ssr-plugin'
import '.n{overflow:hidden;}.ssr-plugin'
import '.j{position:absolute;}.ssr-plugin'
import '.id{top:50%;}.ssr-plugin'
import '.ie{right:1rem;}.ssr-plugin'
import '.if{transform:translateY(-50%);}.ssr-plugin'
import '.ig{width:120px;}.ssr-plugin'
import '.ih{height:120px;}.ssr-plugin'
import '.ii{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.hc{z-index:1;}.ssr-plugin'
import '.am{gap:0.5rem;}.ssr-plugin'
import '.ij{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ce a8 gk a b q b1 p cx n"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="j id ie if ig ih ii a c q"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ce hc a b b1 am ij"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
